import PersonData from './PersonData.container';
export default PersonData;
